import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/dashboard/workspaces/$id')({
  params: z.object({ id: z.string() }),
})
